import Icon from '../components/Icon.vue'

Icon.register({
  'check-double': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M505 174.8c9.3 9.3 9.3 24.5-0.1 34l-296 296.2c-9.3 9.4-24.5 9.4-33.9 0l-168-168.1c-9.4-9.4-9.4-24.6 0-34l39.7-39.7c9.3-9.4 24.5-9.4 33.9 0l111.4 111.5 239.5-239.5c9.3-9.4 24.5-9.4 33.9 0zM180.7 280.8l-112-112.2c-6.2-6.2-6.2-16.3 0-22.6l45.3-45.3c6.2-6.3 16.4-6.3 22.6 0l55.4 55.5 151.5-151.5c6.2-6.3 16.4-6.3 22.6 0l45.2 45.3c6.2 6.2 6.2 16.3 0 22.6l-208 208.2c-6.2 6.3-16.4 6.3-22.6 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/check-double.js
// module id = 1176
// module chunks = 0